<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        small
        color="primary"
        v-on="on"
      >
        <v-icon>
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Job Group Policy Claim"
      text="Edit Job Group Policy Claim"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="localJobGroupPolicyClaim.claimable.name"
                :label="localJobGroupPolicyClaim.claimable.claim_type_id ? 'Claim Entitlement Setting' : 'Claim Type'"
                readonly
                disabled
                outlined
              />
            </v-col>

            <v-col
              cols="12"
            >
              <v-menu
                v-model="startDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="localJobGroupPolicyClaim.start_date"
                    v-validate="'required'"
                    label="Start Date"
                    :error-messages="errors.collect('startDate')"
                    data-vv-name="startDate"
                    data-vv-as="start date"
                    readonly
                    outlined
                    :disabled="$moment(localJobGroupPolicyClaim.start_date) <= $moment().startOf('day')"
                    class="label-position"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="localJobGroupPolicyClaim.start_date"
                  :min="tomorrow"
                  :max="localJobGroupPolicyClaim.end_date"
                  no-title
                  @input="startDateMenu = false"
                />
              </v-menu>
            </v-col>

            <v-col
              cols="12"
            >
              <v-menu
                v-model="endDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="localJobGroupPolicyClaim.end_date"
                    label="End Date"
                    readonly
                    outlined
                    class="label-position"
                    clearable
                    v-on="on"
                    @click:clear="localJobGroupPolicyClaim.end_date = null"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="localJobGroupPolicyClaim.end_date"
                  :min="$moment(localJobGroupPolicyClaim.start_date) > $moment() ? localJobGroupPolicyClaim.start_date : today"
                  no-title
                  @input="endDateMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"  
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"          
          class="white--text px-10"
          @click="submitForm"  
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      jobGroupPolicyClaim: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localJobGroupPolicyClaim: null,
        startDateMenu: false,
        endDateMenu: false,
        today: new Date().toISOString().slice(0, 10),
        tomorrow: new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().slice(0, 10),
      }
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.localJobGroupPolicyClaim = { ...this.jobGroupPolicyClaim }
        }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.jobGroupPolicyClaims().update(this.jobGroupPolicyClaim.id, this.prepareFormData())
              .then(response => {
                if (response.status >= 200 && response.status < 300) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch(() => {
                this.$snack({ 
                  message: 'Unable to update job group policy claim',
                  color: 'error',
                }) 
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          start_date: this.localJobGroupPolicyClaim.start_date,
          end_date: this.localJobGroupPolicyClaim.end_date,
        }
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
